<template>
  <div :class="`${col_class}`">
    <div class="imageContainer" :class="{'border-green': selection_index === index}" @click="handleSelection">
      <img :src="`${imageUrl}`" class="img-thumbnail imagePreview" :key="`img-${index}`">
      <input type="file" ref="uploadInput" @change="handleImageUpload" style="display: none;" :id="`image_file_${index}`"  :name="`image_file_${index}`" :key="`file-${index}`"  v-if="editable">
      <div class="button-container" v-if="editable">
        <button v-if="!imageUploaded" class="btn btn-primary button" @click="uploadImage">
          <template v-if="show_icon">
            <b-icon icon="cloud-upload-fill" aria-hidden="true"></b-icon>
          </template>
          <template v-else>
            Upload
          </template>
        </button>
        <button v-if="imageUploaded" class="btn btn-primary button" @click="editImage">
          <template v-if="show_icon">
            <b-icon icon="pencil-square" aria-hidden="true"></b-icon>
          </template>
          <template v-else>
            Edit
          </template>
        </button>
      </div>
    </div>
    <div class="col-12 p-0" v-if="editable">
      <div v-if="errors && errors.first(`image_file_${index}`)" class="error_msg ml-2 my-1">
        Image is required
      </div>
    </div>
    <div class="collection-dimension-container mt-3" v-if="editable">
      <div class="collection-dimension-radio-container">
        <div class="col-12 p-0">
          <label class="custom-radio align-items-start" :for="isShop ? `shop_dimension_full_width_${index}` : `dimension_full_width_${index}`">
            <span>
              <input type="radio" :id="isShop ? `shop_dimension_full_width_${index}` : `dimension_full_width_${index}`" :name="isShop ? `dimension_full_width_${index}` : `custom_dimension_${index}`" :disabled="!editable" :value="true" v-model="collection_image.fullwidth" :key="isShop ? `shop_custom_dimension_${index}` : `custom_dimension_${index}`"  @change="handleRadioChange"/>
              <span class="radio_icon"></span>
            </span>
            Full Width
          </label>
        </div>
        <div class="col-12 p-0">
          <label class="custom-radio align-items-start" :for="isShop ? `shop_dimension_custom_${index}` : `dimension_custom_${index}`">
            <span>
              <input type="radio" :id="isShop ? `shop_dimension_custom_${index}` : `dimension_custom_${index}`" :name="isShop ? `shop_custom_dimension_${index}` : `custom_dimension_${index}`" :disabled="!editable" :value="false" v-model="collection_image.fullwidth" 
              :key="isShop ? `shop_custom_dimension_${index}` : `custom_dimension_${index}`" @change="handleRadioChange" />
              <span class="radio_icon"></span>
            </span>
            Custom
          </label>
        </div>
      </div>
      <div class="collection-dimension-input-container" v-if="!collection_image.fullwidth">
        <div class="col-md-12 p-0">
          <label class="custom-radio align-items-start" :for="`dimension_width_${index}`">
            <div class="w-100">
              <template v-if="editable">
                <div class="d-flex flex-row align-items-center">
                  W:
                  <div class="d-flex flex-column">
                    <CInput
                        type="text"
                        :id="`dimension_width_${index}`"
                        :name="`dimension_width_${index}`"
                        v-model="collection_image.dimension.width"
                        :class="'required ml-2'"
                        @input="handleInputChange"
                    ></CInput>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="d-flex flex-row align-items-center">
                  W:
                  <div class="d-flex flex-column">
                    <span
                        :id="`dimension_width_${index}`"
                        :class="'required ml-2'"
                    >{{collection_image.dimension.width}}</span>
                  </div>
                </div>
              </template>
            </div>
          </label>
        </div>
        <div class="col-md-12 p-0">
          <label class="custom-radio align-items-start" :for="`dimension_height_${index}`">
            <div class="w-100">
              <template v-if="editable">
                <div class="d-flex flex-row align-items-center">
                  H:
                  <div class="d-flex flex-column">
                    <CInput
                        type="text"
                        :id="`dimension_height_${index}`"
                        :name="`dimension_height_${index}`"
                        v-model="collection_image.dimension.height"
                        :class="'required ml-2'"
                        @input="handleInputChange"
                    ></CInput>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="d-flex flex-row align-items-center">
                  H:
                  <div class="d-flex flex-column">
                    <span
                        :id="`dimension_height_${index}`"
                        :class="'required ml-2'"
                    >{{collection_image.dimension.height}}</span>
                  </div>
                </div>
              </template>
            </div>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    isShop: {
      type: Boolean,
      default: false
    },
    col_class: {
      type: String,
      default: 'col-3'
    },
    show_icon:{
      type:Boolean,
      default: true
    },
    index:{
      type:Number,
      default:0,
    },
    editable:{
      type:Boolean,
      default: false,
    },
    collectionImage:{
      type: Object,
      default: function(){
        return {
          index: 0,
          img_url: null,
          full_width: true,
          dimension: {
            width: null,
            height: null
          }
        }
      }
    },
    selection_index:{
      type: Number,
      default: null
    },
  },
  computed:{
    imageUrl(){
      if(this.collection_image.imageSrc){
        if (!this.collection_image.imageSrc.startsWith('data:image')) {
          return this.storageUrl + '/' + this.collection_image.imageSrc;
        }
        else{
          return this.collection_image.imageSrc
        }
      }
      else{
        return '/img/placeholder.png'
      }
    }
  },
  created() {
    this.setCollectionObject();
  },
  watch: {
    collectionImage: {
      handler(newValue, oldValue) {
        this.setCollectionObject();
      },
      deep: true
    },
    selection_index(newValue) {
      this.internalSelectionIndex = newValue;
    }
  },
  data() {
    return {
      storageUrl: process.env.VUE_APP_FILE_URL,
      internalSelectionIndex:0,
      submitted: false,
      imageUploaded: false,
      file_name: null,
      collection_image: {
        index:0,
        imageSrc: null,
        fullwidth:true,
        dimension:{
          width:null,
          height:null
        }
      }
    };
  },
  methods: {
    handleImageUpload() {
      const file = this.$refs.uploadInput.files[0];
      if (file) {
        this.file_name = file.name;
        const fileType = file.type;
        if (fileType !== 'image/jpeg' && fileType !== 'image/png') {
          this.showToast('Only JPG and PNG images are allowed', 'ERROR')
          return;
        }
        // Check aspect ratio
        const image = new Image();
        image.src = URL.createObjectURL(file);
        image.onload = () => {
          const aspectRatio = image.width / image.height;
          if (aspectRatio <= 1) {
            this.showToast('Aspect ratio must be larger than 1 (width/height)', 'ERROR')
            return;
          }
        }

        // Check file size
        const maxSizeMB = 5; // Max size in MB
        const maxSizeBytes = maxSizeMB * 1024 * 1024; // Convert to bytes
        if (file.size > maxSizeBytes) {
          this.showToast('Maximum file size allowed is 5MB', 'ERROR')
          return;
        }

        this.imageUploaded = true;
        const reader = new FileReader();
        reader.onload = (e) => {
          this.collection_image.imageSrc = e.target.result;
          let imageCollectionDetail = this.createPayload();
          this.$emit("handleImageSubmission", imageCollectionDetail);
          this.imageUploaded = true;
        };

        reader.readAsDataURL(file);
      }
    },
    uploadImage() {
      this.$refs.uploadInput.click();
    },
    editImage() {
      this.$refs.uploadInput.click();
    },
    setCollectionObject(){
      this.collection_image.index = this.collectionImage.index;
      this.collection_image.imageSrc = this.collectionImage.img_url;
      this.collection_image.fullwidth = this.collectionImage.full_width;
      this.collection_image.dimension.width = this.collectionImage.dimension.width;
      this.collection_image.dimension.height = this.collectionImage.dimension.height;
      this.imageUploaded = this.collectionImage.img_url ? true:false;
    },
    handleSelection(){
      this.internalSelectionIndex = this.index;
      this.collection_image.index = this.index;
      this.$emit("clearSelectionExcept",this.collection_image);
      let imageCollectionDetail = this.createPayload();
      this.$emit("handleImageSubmission", imageCollectionDetail);
    },
    handleRadioChange(){
      console.log('handle radio change')
      let imageCollectionDetail = this.createPayload();
      this.$emit("handleImageSubmission", imageCollectionDetail);
    },
    handleInputChange(){
      let imageCollectionDetail = this.createPayload();
      console.log('sd', imageCollectionDetail)
      this.$emit("handleImageSubmission", imageCollectionDetail);
    },
    createPayload(){
      return {
        index: this.index,
        img_url: this.collection_image.imageSrc,
        full_width: this.collection_image.fullwidth,
        file_name: this.file_name,
        dimension: {
          width: this.collection_image.dimension.width,
          height: this.collection_image.dimension.height
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.imageContainer {
  position: relative;
  max-width: 300px;
  max-height: 300px;
  overflow: hidden;
}

.imagePreview {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.button-container {
  position: absolute;
  bottom: 0;
  left: 0;
  opacity: 0;
  transition: opacity 0.3s ease;
  top: 0;
  right: 0;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0,0,0,0.3);
  border-radius: 0.25rem;
}

.imageContainer:hover .button-container {
  opacity: 1;
}
.border-green {
  border: 2px solid #00FF00;
  border-radius: 0.25rem
}

.button {
  padding: 10px;
  border: none;
  cursor: pointer;
  margin: 5px;
  transition: background-color 0.3s ease;
}

.custom-radio{
  display: flex;
  align-items: center;
  gap: 10px;

  .radio_text{
    &>*{
      margin:0;
      padding: 0;
    }
  }

  &>span{
    .radio_icon {
      display: block;
      flex-shrink: 0;
      width: 20px;
      height: 20px;
      border: 1px solid #009FE3; /* Green color for the checkmark */
      border-radius: 50%; /* Makes the border circular */
      position: relative;

      /* Rotating the square to create a checkmark */
      transform: rotate(0);
    }

    /* Styling for the checkmark itself */
    .radio_icon::before,
    .radio_icon::after {
      display: none;
      content: '';
      position: absolute;
      background-color: #fff; /* Green color for the checkmark */
    }

    .radio_icon::before {
      width: 6px;
      height: 2px;
      top: 9px;
      left: 3px;
      transform: rotate(45deg);
    }

    .radio_icon::after {
      width: 2px;
      height: 10px;
      top: 4px;
      left: 10px;
      transform: rotate(45deg);
    }

    input{
      display: none;

      &:disabled{
        &+.radio_icon{
          cursor: not-allowed;
          background-color: #eee;
          border-color: #ccc;

          &::before,
          &::after {
            display: block;
            background-color: #eee;
          }
        }
      }

      &:checked{
        &+.radio_icon{
          background-color: #009FE3;

          &::before,
          &::after {
            display: block;
            background-color: #fff;
          }
        }

        &:disabled{
          &+.radio_icon{
            cursor: not-allowed;
            background-color: #ccc;
            border-color: #aaa;

            &::before,
            &::after {
              display: block;
              background-color: #fff;
            }
          }
        }
      }
    }
  }

  &.checkbox{
    &>span {
      .radio_icon {
        border-radius: 20%;
      }
    }
  }
}
</style>